module.exports = __webpack_public_path__ + "@/assets/img/angle-down.2bda8254.svg";